<div class="cookie-banner" *ngIf="showCookiesBar" id="cookiebar">
  <div class="cookie-banner-copy">
    <div class="cookie-banner-title">
      <mat-icon>cookie</mat-icon>
      <span>Cookie Preferences</span>
    </div>
    <p>
      This portal uses essential cookies so it can remember your preferences and keep you signed in.
    </p>
  </div>

  <div class="cookie-banner-actions">
    <button mat-stroked-button color="primary" id="cookie-details-button" type="button" (click)="openDetails()">
      Learn More
    </button>
    <button mat-raised-button color="primary" id="cookie-accept-button" type="button" (click)="acceptCookies()">
      Accept
    </button>
  </div>
</div>

<ng-template #cookieDialog>
  <h2 mat-dialog-title id="cookie-dialog-title" class="dialog-title">
    <span class="title-text">Cookie Preferences</span>
    <button mat-icon-button type="button" class="close-icon" id="cookie-dialog-close-button" (click)="closeDialog()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <mat-tab-group [mat-stretch-tabs]="false">
      <mat-tab label="Privacy Overview">
        <div class="cookie-tab-content">
          <p>
            The License Portal uses cookies so that we can provide you with the best user experience possible.
            Cookie information is stored in your browser and helps the portal remember your preferences between visits.
          </p>
        </div>
      </mat-tab>

      <mat-tab label="Strictly Necessary">
        <div class="cookie-tab-content">
          <p>
            Strictly necessary cookies keep you signed in and preserve interface preferences such as theme selection
            and cookie consent.
          </p>
          <div class="cookie-setting">
            <mat-checkbox checked disabled id="necessary-cookies-checkbox">Always enabled</mat-checkbox>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="3rd Party Cookies">
        <div class="cookie-tab-content">
          <p>No third-party cookies are used on the License Portal.</p>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="accent" id="cookie-close-button" type="button" (click)="closeDialog()">
      Close
    </button>
    <button mat-raised-button color="primary" id="cookie-accept-dialog-button" type="button" (click)="acceptCookies()">
      Accept
    </button>
  </mat-dialog-actions>
</ng-template>
